export default __webpack_public_path__ + "static/media/tech.1c976700.svg";